export const GET_DISPOSITIVOS_SUCCESS = 'dispositivos/GET_DISPOSITIVOS_SUCCESS';
export const GET_DISPOSITIVOS_LOADING = 'dispositivos/GET_DISPOSITIVOS_LOADING';
export const GET_DISPOSITIVOS_FAILURE = 'dispositivos/GET_DISPOSITIVOS_FAILURE';
